import { defineStore } from 'pinia'

import { getRegionList, getRegion, getRegionDetect } from '@/service/region'
import type { RegionRegionInfoData, RegionRegionDetectInfo, SregionRegionsListInfo } from '@/types/api'

export type RegionOption = {
  id: number
  name: string
}

export const useRegionStore = defineStore('region', () => {
  const currentRegionId = ref<number | undefined>()
  const regionList = ref<SregionRegionsListInfo[]>([])
  const regionDetectInfo = ref<RegionRegionDetectInfo>()
  const regionInfo = ref<RegionRegionInfoData | undefined>()

  const currentRegion = computed<SregionRegionsListInfo | undefined>(
    () => regionList.value.find(region => region.region_id === currentRegionId.value) || regionList.value[0]
  )
  const regionOptions = computed<RegionOption[]>(() => regionList.value.map(region => ({ name: region.name!, id: region.region_id! })))
  const selectedRegionOption = computed(() => regionOptions.value.find(({ id }) => id === currentRegionId.value))

  const fetchRegionList = async () => {
    const { data } = await getRegionList()
    regionList.value = data.list
    return data
  }

  const fetchRegion = async (id: number) => {
    const { data } = await getRegion(id)
    regionInfo.value = data
    return data
  }

  const fetchRegionDetect = async () => {
    const { data } = await getRegionDetect()
    regionDetectInfo.value = data
    return data
  }

  return {
    currentRegionId,
    regionList,
    regionDetectInfo,
    regionInfo,
    currentRegion,
    regionOptions,
    selectedRegionOption,
    fetchRegionList,
    fetchRegion,
    fetchRegionDetect,
  }
})
